import setAsset from '../base-saving-actions/set-asset';

const createAssets = (assetsToCreate) =>
  assetsToCreate.map(({ source, content }) => setAsset(source, { content }));

export default createAssets;
